import React from 'react';
import PropTypes from 'prop-types';
import * as classes from './classes.module.scss';

const style = (dpi) => ({
  width: dpi
});

const Meter = ({ dpi }) => (
  <div className={ classes.meter } style={ style(dpi) }>
    <span style={ style(dpi) }>
      1&quot;
    </span>
  </div>
);

Meter.propTypes = {
  dpi: PropTypes.number.isRequired
};

export default Meter;
